import React, { useEffect } from 'react';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import NavigateNext from '@material-ui/icons/NavigateNext';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import Paper from '@material-ui/core/Paper';
import { object, bool, func } from 'prop-types';
import { Link } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useTranslation } from 'react-i18next';
import SupportingDocuments from '../../forms/Application/SupportingDocuments';
import Footer from '../components/Footer';

let styles = theme => ({
  rootContainer: {
    marginTop: theme.spacing(10),
  },
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    height: '100%',
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonBackTo: {
    backgroundColor: '#0280CA',
    color: '#ffffff',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonBack: {
    backgroundColor: '#b22a00',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  buttonLeft: {
    backgroundColor: '#b22a00',
    color: '#ffffff',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonRight: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: '#357a38',
  },
  buttonRightSingle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  buttonLeftContainer: {
    display: 'flex',
  },
  buttonRightContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  progress: {
    flexGrow: 1,
  },
});

let theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function SupportingDocsPage(props) {
  let {
    classes,
    isFetching,
    error,
    hasAllRequiredDocuments,
    isLoaded,
    loadData,
  } = props;
  let { t } = useTranslation();

  useEffect(() => {
    if (!isLoaded) {
      loadData();
    }
  }, [isLoaded, loadData]);

  return (
    <div className={classes.rootContainer}>
      <Grid
        container
        alignItems="center"
        direction="row"
        justifyContent="center"
      >
        <Grid item xs={11}>
          <Typography variant="h4" align="center" gutterBottom>
            {t('applicationForm')}
          </Typography>
        </Grid>
        <Grid item xs={11}>
          <Paper className={classes.root} elevation={3}>
            {isFetching && <LinearProgress className={classes.progress} />}
            <SupportingDocuments />
          </Paper>
        </Grid>
        <Grid container direction="row" justifyContent="space-around">
          <Grid item xs={5} className={classes.buttonLeftContainer}>
            <MuiThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                disabled={isFetching}
                className={classes.buttonBackTo}
                component={Link}
                to={'/applications'}
              >
                {t('backTo')}
              </Button>
            </MuiThemeProvider>
          </Grid>
          <Grid item className={classes.buttonRightContainer} xs={5}>
            <Button
              component={Link}
              to="/application"
              variant="contained"
              color="secondary"
              className={classes.buttonBack}
              disabled={isFetching}
            >
              <NavigateBefore className={classes.leftIcon} />
              {t('back')}
            </Button>
            <MuiThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to={'/view'}
                className={classes.buttonRight}
                disabled={error || isFetching || !hasAllRequiredDocuments}
              >
                {t('continue')}
                <NavigateNext className={classes.rightIcon} />
              </Button>
            </MuiThemeProvider>
          </Grid>
        </Grid>
      </Grid>

      <Footer />
    </div>
  );
}

SupportingDocsPage.propTypes = {
  classes: object.isRequired,
  isFetching: bool.isRequired,
  isLoaded: bool.isRequired,
  error: bool,
  loadData: func.isRequired,
  hasAllRequiredDocuments: bool.isRequired,
};

export default withStyles(styles)(SupportingDocsPage);



// WEBPACK FOOTER //
// ./src/view/scenes/SupportingDocs/SupportingDocsPage.js